import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'


// 大赛
import CompetitionView from "@/views/competition/CompetitionView"
import IntroductionView from "@/views/competition/IntroductionView"
import AnnouncementView from "@/views/competition/AnnouncementView"
import PreviousView from "@/views/competition/PreviousView"
import RegisterView from "@/views/competition/RegisterView"
// 个人中心
import CenterView from "@/views/mycenter/CenterView"
import BasicInformation from "@/views/mycenter/BasicInformation"
import MyAppointment from "@/views/mycenter/MyAppointment"
import MyCollection from "@/views/mycenter/MyCollection"
import MyAchievements from "@/views/mycenter/MyAchievements"
import MyDemands from "@/views/mycenter/MyDemands"
import MyScientist from "@/views/mycenter/MyScientist"
import ShujuwulianVerify from "@/views/shujuwuliancom/ShujuwulianVerify"

// 供需对接
import supplyAndDemmandCenter from "@/views/supplyAndDemmand/supplyAndDemmandCenter"
import SupplyView from "@/views/supplyAndDemmand/SupplyView"
import DemmandView from "@/views/supplyAndDemmand/DemmandView"

const routes = [
  {
    path: '/',
    component: HomeView
  },
  {
    path: '/about',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue'),
    meta: {
      title: "测试页", // 标题
    }
  },
  {
    path: '/noticeannouncement',
    component: () => import(/* webpackChunkName: "about" */ '../views/notice/NoticeAnnouncementView.vue'),
    meta: {
      title: "通知公告", // 标题
    }
  },
  {
    path: '/noticeannouncementDetail',
    component: () => import(/* webpackChunkName: "about" */ '../views/notice/NoticeAnnouncementViewDetail.vue'),
    meta: {
      title: "通知公告详情", // 标题
    }
  },
  {
    path: '/comNotice',
    component: () => import(/* webpackChunkName: "about" */ '../views/notice/ComNotice.vue'),
    meta: {
      title: "大赛通知公告", // 标题
    }
  },
  {
    path: '/comNoticeDetail',
    component: () => import(/* webpackChunkName: "about" */ '../views/notice/ComNoticeDetail.vue'),
    meta: {
      title: "大赛通知公告详情", // 标题
    }
  },

  {
    path: '/equipmentsharing',
    component: () => import(/* webpackChunkName: "about" */ '../views/equipment/equipmentListView.vue'),
    meta: {
      title: "设备共享", // 标题
    }
  },
  {
    path: '/equipmentDetail',
    component: () => import(/* webpackChunkName: "about" */ '../views/equipment/equipmentDetailView.vue'),
    meta: {
      title: "设备详情", // 标题
    }
  },
  {
    path: '/competitionquestion',
    component: () => import(/* webpackChunkName: "about" */ '../views/competition/CompetitionQuestion.vue'),
    meta: {
      title: "大赛问题反馈", // 标题
    }
  },
  {
    path: '/competitionquestionadd',
    component: () => import(/* webpackChunkName: "about" */ '../views/competition/CompetionQuestionAddView.vue'),
    meta: {
      title: "发布大赛问题反馈", // 标题
    }
  },
  {
    path: '/competitionquestiondetail',
    component: () => import(/* webpackChunkName: "about" */ '../views/competition/CompetionQuestionDetailView.vue'),
    meta: {
      title: "大赛问题详情", // 标题
    }
  },
  {
    path: '/competionverify',
    component: () => import(/* webpackChunkName: "about" */ '../views/competition/CompetionVerify.vue'),
    meta: {
      title: "大赛审核列表", // 标题
    }
  },
  {
    path: '/CompetitionQAdmin',
    component: () => import(/* webpackChunkName: "about" */ '../views/competition/CompetitionQAdmin.vue'),
    meta: {
      title: "大赛评审页", // 标题
    }
  },
  {
    path: '/competition',
    // redirect:"/competition/introduction",
    component: CompetitionView,
    meta: {
      title: "微纳大赛", // 标题
    },
    // 请注意，只有子路由具有名称
    children:[
      {
        path: 'introduction',
        component: IntroductionView,
      },
      {
        path: 'announcement',
        component: AnnouncementView,
      },
      {
        path: 'previous',
        component:PreviousView,
      },
      {
        path: 'register',
        component: RegisterView,
      }
    ]
  },
  {
    path: '/datadownload',
    component: () => import(/* webpackChunkName: "about" */ '../views/DataDownloadView.vue'),
    meta: {
      title: "资料下载", // 标题
    }
  },
  {
    path: '/dataDownload',
    component: () => import(/* webpackChunkName: "about" */ '../views/DataDownloadView.vue'),
    meta: {
      title: "资料下载", // 标题
    }
  },
  {
    path: '/platformintroduction',
    component: () => import(/* webpackChunkName: "about" */ '../views/PlatformIntroductionView.vue'),
    meta: {
      title: "平台介绍", // 标题
    }
  },
  {
    path: '/scientist',
    component: () => import(/* webpackChunkName: "about" */ '../views/scientist/YoungScientist.vue'),
    meta: {
      title: "青年科学家招募", // 标题
    }
  },
  {
    path: '/scientistApply',
    component: () => import(/* webpackChunkName: "about" */ '../views/scientist/ScientistApply.vue'),
    meta: {
      title: "青年科学家申请", // 标题
    }
    },
  {
    path: '/center', // 个人中心
    redirect: "/center/basicinformation",
    component: CenterView,
    beforeEnter: (to, from) => {
      // reject the navigation
      // console.log(333,to,from)
      // return false
    },
    children:[
      // {
      //   path: "",
      //   redirect: 'basicinformation',
      // },
      {
        path: 'basicinformation',
        name:"basicinformation",
        component:BasicInformation,
        beforeEnter: (to, from) => {
          // reject the navigation
          console.log(333,to,from)
          // return false
        },
        // component: import(/* webpackChunkName: "about" */ '../views/mycenter/BasicInformation.vue'),
      },
      // {
      //   path: 'basicinformation',
      //   name:"basicinformation",
      //   component: import(/* webpackChunkName: "about" */ '../views/mycenter/BasicInformation.vue'),
      // },
      {
        path: 'myappointment',
        name:"myappointment",
        component: MyAppointment,
      },
      {
        path: 'mymollection',
        name:"mymollection",
        component: MyCollection,
      },
      {
        path: 'myachievements',
        name:"myachievements",
        component: MyAchievements,
      },
      {
        path: 'mydemands',
        name:"mydemands",
        component: MyDemands,
      },
      {
        path: 'shujuwulianverify',
        name:"shujuwulianverify",
        component: ShujuwulianVerify,
      },
      {
        path: 'myscientist',
        name:"myscientist",
        component: MyScientist,
      }
    ]
  },
  {
    path: '/supplysndsemand', // 供需对接
    redirect: "/supplysndsemand/supply",
    component: supplyAndDemmandCenter,
    children:[
      // {
      //   path: "",
      //   redirect: 'supply',
      // },
      {
        path: 'supply',
        component: SupplyView,
      },
      {
        path: 'demmand',
        component: DemmandView,
      }
    ]
  },
  {
    path: '/demmandadd',
    component: () => import(/* webpackChunkName: "about" */ '../views/supplyAndDemmand/DemmandAddView.vue'),
    meta: {
      title: "需求添加", // 标题
    }
  },
  {
    path: '/demmandedit',
    component: () => import(/* webpackChunkName: "about" */ '../views/supplyAndDemmand/DemmandEditView.vue'),
    meta: {
      title: "需求编辑", // 标题
    }
  },
  {
    path: '/demmandDetail',
    component: () => import(/* webpackChunkName: "about" */ '../views/supplyAndDemmand/DemmandDetailView.vue'),
    meta: {
      title: "需求详情", // 标题
    }
  },
  {
    path: '/myDemmandDetail',
    component: () => import(/* webpackChunkName: "about" */ '../views/supplyAndDemmand/MyDemmandDetailView.vue'),
    meta: {
      title: "我发布的需求详情", // 标题
    }
  },
  {
    path: '/supplyadd',
    component: () => import(/* webpackChunkName: "about" */ '../views/supplyAndDemmand/SupplyAddView.vue'),
    meta: {
      title: "成果添加", // 标题
    }
  },
  {
    path: '/supplyedit',
    component: () => import(/* webpackChunkName: "about" */ '../views/supplyAndDemmand/SupplyEditView.vue'),
    meta: {
      title: "成果编辑", // 标题
    }
  },
  {
    path: '/supplyDetail',
    component: () => import(/* webpackChunkName: "about" */ '../views/supplyAndDemmand/SupplyDetailView.vue'),
    meta: {
      title: "成果详情", // 标题
    }
  },
  {
    path: '/mySupplyDetail',
    component: () => import(/* webpackChunkName: "about" */ '../views/supplyAndDemmand/MySupplyDetailView.vue'),
    meta: {
      title: "我发布的成果详情", // 标题
    }
  },
  //  沭聚物联
  {
    path: '/shujuwulian',
    component: () => import(/* webpackChunkName: "about" */ '../views/shujuwuliancom/ShujuwulianQList.vue'),
    meta: {
      title: "沭聚物联问题列表", // 标题
    }
  },
  {
    path: '/shujuwulianquestionadd',
    component: () => import(/* webpackChunkName: "about" */ '../views/shujuwuliancom/ShujuwulianQAddView.vue'),
    meta: {
      title: "沭聚物联发布问题反馈", // 标题
    }
  },
  {
    path: '/shujuwulianquestiondetail',
    component: () => import(/* webpackChunkName: "about" */ '../views/shujuwuliancom/ShujuwulianQDetailView.vue'),
    meta: {
      title: "沭聚物联问题详情", // 标题
    }
  },
  {
    path: '/shujuwulianquestionQAdmin',
    component: () => import(/* webpackChunkName: "about" */ '../views/shujuwuliancom/ShujuwulianQAdmin.vue'),
    meta: {
      title: "沭聚物联评审页", // 标题
    }
  },
  {
    path: '/shujuwulianverify',
    component: () => import(/* webpackChunkName: "about" */ '../views/shujuwuliancom/ShujuwulianVerify.vue'),
    meta: {
      title: "大赛审核列表", // 标题
    }
  },
  {
    path: '/comroombook',
    component: () => import(/* webpackChunkName: "about" */ '../views/competition/RoomBookView.vue'),
    meta: {
      title: "大赛订房", // 标题
    }
  },
  {
    path: '/comroombooktest',
    component: () => import(/* webpackChunkName: "about" */ '../views/competition/RoomBookViewTODOTEST.vue'),
    meta: {
      title: "大赛订房测试用", // 标题
    }
  },
  {
    path: '/comroombookdone',
    component: () => import(/* webpackChunkName: "about" */ '../views/competition/comroombookdone.vue'),
    meta: {
      title: "房间预定", // 标题
    }
  },
  {
    path: '/thinktank',
    component: () => import(/* webpackChunkName: "about" */ '../views/thinktank/thinktankListView.vue'),
    meta: {
      title: "专家库列表", // 标题
    }
  },
  {
    path: '/thinkdetail',
    component: () => import(/* webpackChunkName: "about" */ '../views/thinktank/thinkDetailView.vue'),
    meta: {
      title: "专家库详情", // 标题
    }
  },
  {
    path: '/:path(.*)',
    name: '404',
    meta: {},
    component: () => import(/* webpackChunkName: "about" */ '../views/ErrorPage.vue')
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes:routes,
  scrollBehavior(to, from, savedPosition) {
    // 始终滚动到顶部
    return { top: 0,behavior: 'smooth' }
  },
  mode: 'history',
  // strict: false, // applies to all routes
})

router.afterEach((to, from) => {
  const toDepth = to.path.split('/').length
  const fromDepth = from.path.split('/').length
  to.meta.transition = toDepth < fromDepth ? 'slide-right' : 'slide-left'
})

export default router
